/**
 * Connection Status Component
 * Displays connection state and peer count
 */

import React from 'react';
import { Tag } from 'antd';
import {
  LoadingOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import type { ConnectionStatusProps } from '@/api/types/webrtc.types';
import './ConnectionStatus.css';

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({
  state,
  peersCount,
}) => {
  const getStatusConfig = () => {
    switch (state) {
      case 'idle':
        return {
          icon: <WarningOutlined />,
          color: 'default',
          text: 'Not connected',
        };
      case 'connecting':
        return {
          icon: <LoadingOutlined spin />,
          color: 'processing',
          text: 'Connecting...',
        };
      case 'connected':
        return {
          icon: <CheckCircleOutlined />,
          color: 'success',
          text: 'Connected',
        };
      case 'disconnected':
        return {
          icon: <WarningOutlined />,
          color: 'warning',
          text: 'Disconnected',
        };
      case 'failed':
        return {
          icon: <CloseCircleOutlined />,
          color: 'error',
          text: 'Connection failed',
        };
      default:
        return {
          icon: <WarningOutlined />,
          color: 'default',
          text: 'Unknown',
        };
    }
  };

  const { icon, color, text } = getStatusConfig();

  return (
    <div className="connection-status-wrapper">
      <Tag icon={icon} color={color} className="connection-status-tag">
        {text}
      </Tag>

      {peersCount > 0 && (
        <Tag color="blue" className="peers-count-tag">
          👥 {peersCount} {peersCount === 1 ? 'participant' : 'participants'}
        </Tag>
      )}
    </div>
  );
};
